import { render, staticRenderFns } from "./TreatmentModal.vue?vue&type=template&id=7e293ed4&scoped=true"
import script from "./TreatmentModal.vue?vue&type=script&lang=ts"
export * from "./TreatmentModal.vue?vue&type=script&lang=ts"
import style0 from "./TreatmentModal.vue?vue&type=style&index=0&id=7e293ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e293ed4",
  null
  
)

export default component.exports